import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import dashboardReducer from "./dashboardReducer/dashboardReducer";
import groupReducer from "./groupReducer/groupReducer";
import mrgReducer from "./mrgReducer/mrgReducer";
import { MrgActionTypes } from "./mrgReducer/mrgTypes";
import storeReducer from "./storeReducer/storeReducer";

export const reducer = combineReducers({
  form: formReducer,
  mrg: mrgReducer,
  group: groupReducer,
  store: storeReducer,
  dashboard: dashboardReducer,
});

export const rootReducer = (state: any, action: any) => {
  let _state: RootState | undefined = state;
  if (action.type === MrgActionTypes.LOG_OUT) {
    _state = undefined;
  }
  return reducer(_state, action);
};
